/** Company primary actions use the applied interface tokens, or the standard gold/ink defaults. */
export const defaultCompanyPrimaryAction = { fill: '#e8bf21', text: '#1a1918' };

export const resolveCompanyPrimaryAction = (configuration: unknown) => {
  const source = configuration && typeof configuration === 'object'
    ? (configuration as { interfaceTokens?: unknown }).interfaceTokens
    : null;
  const tokens = source && typeof source === 'object'
    ? source as Record<string, unknown> : {};
  const color = (value: unknown, fallback: string) =>
    typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value) ? value : fallback;
  return {
    fill: color(tokens.brandPrimary, defaultCompanyPrimaryAction.fill),
    text: color(tokens.brandPrimaryText, defaultCompanyPrimaryAction.text)
  };
};

/** The selected Contracts header palette, shared by Admin actions. */
export const selectedHeaderPalette = {
  border: '#7c6330',
  text: '#f7df9c',
  backgroundImage:
    'linear-gradient(180deg,rgba(245,206,123,0.22),rgba(255,255,255,0.06))',
  shadow: '0 10px 26px rgba(232,191,33,0.12)'
};

export const adminActionButtonSx = {
  // Give the translucent header highlight its dark backing on light pages.
  backgroundColor: '#202020',
  backgroundImage: selectedHeaderPalette.backgroundImage,
  color: selectedHeaderPalette.text,
  borderColor: selectedHeaderPalette.border,
  borderStyle: 'solid',
  borderWidth: 1,
  boxShadow: selectedHeaderPalette.shadow,
  textTransform: 'none' as const,
  '&:hover': {
    backgroundColor: '#303030',
    backgroundImage: selectedHeaderPalette.backgroundImage,
    color: selectedHeaderPalette.text,
    borderColor: selectedHeaderPalette.border,
    boxShadow: selectedHeaderPalette.shadow
  },
  '&:focus-visible, &.Mui-focusVisible': {
    outline: `2px solid ${selectedHeaderPalette.border}`,
    outlineOffset: 3
  },
  '&:active': {
    backgroundColor: '#202020',
    boxShadow: 'none'
  },
  '&.Mui-disabled': {
    backgroundColor: '#eeeeee',
    backgroundImage: 'none',
    color: '#626262',
    borderColor: '#bdbdbd',
    boxShadow: 'none'
  }
};
